import { isFeatureEnabled } from '@lumapps/features/ducks/selectors';

export const FRONTIERS_ALPHA_FF = 'frontiers-alpha';
export const isFrontiersAlphaEnabled = isFeatureEnabled(FRONTIERS_ALPHA_FF);

export const MEDIA_LIBRARY_SCOPE = 'media-library';

export const MEDIA_LIBRARY_PATH = 'media/library';

export const IMAGE_TYPE = 'image';

export enum FILE_DRAWER_TABS {
    SETTINGS,
    VERSION_HISTORY,
}

export enum MEDIA_LIBRARY_ACTION_KEYS {
    COPY = 'copy',
    DELETE = 'delete',
    DOWNLOAD = 'download',
    EDIT = 'edit',
    MORE_INFORMATION = 'more-information',
    MOVE = 'move',
    RENAME = 'rename',
    REPLACE = 'replace',
}

export const MEDIA_LIBRARY_ACTION_ORDER = [
    MEDIA_LIBRARY_ACTION_KEYS.MORE_INFORMATION,
    MEDIA_LIBRARY_ACTION_KEYS.DOWNLOAD,
    MEDIA_LIBRARY_ACTION_KEYS.EDIT,
    MEDIA_LIBRARY_ACTION_KEYS.REPLACE,
    MEDIA_LIBRARY_ACTION_KEYS.COPY,
    MEDIA_LIBRARY_ACTION_KEYS.MOVE,
    MEDIA_LIBRARY_ACTION_KEYS.DELETE,
];

export enum ACTION_TYPE {
    CELL = 'cell',
    DRAWER = 'drawer',
}
